import {useLocation} from "react-router-dom";
import {UnsubscribeView} from "@/components/shop/UnsubscribeView";

export function DezabonarePageClient() {
  const {pathname} = useLocation();
  const m = pathname.match(/\/(?:unsubscribe|dezabonare)\/([^/?]+)/);
  const hash = m?.[1] || "";
  if(!hash) return <p className="notfound">Not found</p>;
  return <UnsubscribeView hash={hash} />;
}
